import { render, staticRenderFns } from "./ModalAgreement.vue?vue&type=template&id=5f227848&scoped=true&"
import script from "./ModalAgreement.vue?vue&type=script&lang=js&"
export * from "./ModalAgreement.vue?vue&type=script&lang=js&"
import style0 from "./ModalAgreement.vue?vue&type=style&index=0&id=5f227848&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f227848",
  null
  
)

export default component.exports